import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class PrivateFileService {
  DoGenerateSASToken(input: any) {
    return service.peakFileService
      .post("/api/Token/GenerateSASToken", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }
}
export default new PrivateFileService();
